<div class="mx-3 mat-elevation-z2">
  <div
    class="row row-lt-md-column justify-start align-center gap-3"
    style="padding: 0.5em 1em"
  >
    <div
      class="row-wrap justify-start align-end gap-3"
      style="padding: 0 1em"
    >
      <!-- Select Cliente -->
      <ng-select
        style="width: 200px"
        [items]="clientes"
        [(ngModel)]="idCliente"
        [hideSelected]="true"
        placeholder="Cliente"
        [searchable]="true"
        bindLabel="nombre"
        bindValue="_id"
        (change)="listar()"
      />

      <!-- Select Modo Registro -->
      <ng-select
        style="width: 300px"
        [items]="modosRegistro"
        [(ngModel)]="modoRegistro"
        [hideSelected]="true"
        placeholder="Modo de Registro"
        [searchable]="true"
        bindLabel="viewValue"
        bindValue="value"
        (change)="listar()"
      />

      <!-- Agrupacion -->
      <mat-form-field style="width: 300px">
        <mat-label>Agrupación</mat-label>
        <mat-select [(ngModel)]="agrupacion" (selectionChange)="listar()">
          <mat-option value="Modo de Registro"> Modo de Registro </mat-option>
          <mat-option value="Cliente"> Cliente </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Resumen -->
    <div class="column">
      <p style="margin: 0">
        Registrados en los últimos {{ dias }} días:
        <strong>{{ totalCount }}</strong>
      </p>
      <p style="margin: 0">
        Promedio diario: <strong>{{ promedioDiario }}</strong>
      </p>
      <p style="margin: 0">
        Registrados Hoy: <strong>{{ registradosHoy }}</strong>
      </p>
    </div>
  </div>

  <!-- Graficos -->
  <div>
    <mat-tab-group>
      <mat-tab label="Cantidad de registros por día">
        <ng-template matTabContent>
          @if (chartOptionsFechaCreacion) {
            <app-chart
              [(options)]="chartOptionsFechaCreacion"
              style="
                max-width: 100%;
                height: 400px;
                display: block;
                margin-top: 30px;
                margin: auto;
              "
            />
          }
        </ng-template>
      </mat-tab>
      <mat-tab label="Promedio de registros por hora">
        <ng-template matTabContent>
          @if (chartOptionsHoraHoy) {
            <app-chart
              [(options)]="chartOptionsHoraHoy"
              style="
                max-width: 100%;
                height: 400px;
                display: block;
                margin-top: 30px;
                margin: auto;
              "
            />
          }
        </ng-template>
      </mat-tab>
      <mat-tab label="Cantidad de regitros por edad">
        <ng-template matTabContent>
          @if (chartOptionsEdad) {
            <app-chart
              [(options)]="chartOptionsEdad"
              style="
                max-width: 100%;
                height: 400px;
                display: block;
                margin-top: 30px;
                margin: auto;
              "
            />
          }
        </ng-template>
      </mat-tab>
      <mat-tab label="Acumulado Vecinos por mes">
        <ng-template matTabContent>
          @if (chartOptionsMes) {
            <app-chart
              [(options)]="chartOptionsMes"
              (chartInstanceEvent)="onChartInstance($event)"
              style="
                max-width: 100%;
                height: 400px;
                display: block;
                margin-top: 30px;
                margin: auto;
              "
            />
          }
          <button
            mat-fab
            matTooltip="Exportar"
            color="primary"
            style="position: absolute; top: 10px; right: 10px"
            (click)="exportarAcumuladoMensualExcel()"
          >
            Exportar
          </button>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
